import Vue from 'vue'
import Vuex from 'vuex'
import main from './modules/main'
import home from './modules/home'
import order from './modules/order'
import store from './modules/store'
import voucher from './modules/voucher'
import appointment from './modules/appointment'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)
const StoreIns = new Vuex.Store({
  modules: {
    main,
    home,
    order,
    store,
    voucher,
    appointment
  },
  strict: debug
})

export default StoreIns
